import { fromJS } from 'immutable';

export function request(state) {
    return state.set('liveGamesCategories', {
        status: 'IN_PROGRESS'
    });
}

export function finish(state, { liveGamesCategories }) {
    return state.set('liveGamesCategories', {
        status: 'FINISHED',
        items: liveGamesCategories
    });
}

export function error(state) {
    return state.set('liveGamesCategories', {
        status: 'ERROR'
    });
}
